"use client";

import { useMemo } from "react";
import { useClient, useWallet } from "@getpara/react-sdk";
import { ParaSolanaWeb3Signer } from "@getpara/solana-web3.js-v1-integration";
import { Connection } from "@solana/web3.js";
import { useParaAccount } from "./use-appkit-account";

export function useParaSolana() {
  const para = useClient();
  const { data: wallet } = useWallet();
  const { isExternalSolana } = useParaAccount();

  // Extract primitive values for stable dependencies
  const walletId = wallet?.id;
  const walletType = wallet?.type;
  const isExternal = wallet?.isExternal;

  const { connection, signer } = useMemo(() => {
    const connection = new Connection(
      typeof window !== "undefined"
        ? `${window.location.origin}/api/rpc?chain=solana`
        : "https://api.mainnet-beta.solana.com",
      { commitment: "confirmed" }
    );

    // Return null signer if not a Para Solana wallet
    if (!para || !walletId || isExternalSolana || isExternal) {
      return { connection, signer: null };
    }

    if (walletType !== "SOLANA") {
      return { connection, signer: null };
    }

    // Wrap in try-catch because ParaSolanaWeb3Signer can throw
    // if Para SDK is in an intermediate state during chain switches
    try {
      const signer = new ParaSolanaWeb3Signer(
        para as any,
        connection,
        walletId
      );
      return { connection, signer };
    } catch (error) {
      console.warn("Failed to create ParaSolanaWeb3Signer:", error);
      return { connection, signer: null };
    }
  }, [para, walletId, walletType, isExternal, isExternalSolana]);

  return { connection, signer };
}
